module.exports = __webpack_public_path__ + "static/media/configuracion.b889df88.svg";